import { render, staticRenderFns } from "./MobileSubmitInfo.vue?vue&type=template&id=1a16db5b&"
import script from "./MobileSubmitInfo.vue?vue&type=script&lang=js&"
export * from "./MobileSubmitInfo.vue?vue&type=script&lang=js&"
import style0 from "./MobileSubmitInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports